import styled, { css } from 'styled-components';

import { transition } from 'ggApp/utils/mixins/transition';

import Container from 'ggApp/shared/common/Container';

import Overlay from './Overlay';

import CounterButton from './CounterButton';

const visiblePopUp = css`
    visibility: visible;
    opacity: 1;
    transform: scale(1);
    ${transition('all', '0.2s', 'in')};
`;

const Wrap = styled(Container)`
    position: relative;
`;

const Button = styled(CounterButton)``;

const CartOverlay = styled(Overlay)`
    ${({ theme }) => theme.superQuery.all.and.minWidth.desktopMin.css`
        position: absolute;
        right: 0;
        top: 60px;
        visibility: hidden;
        opacity: 0;
        transform: scale(0.9);
        ${transition('all', '0.2s', 'out')};
        ${({ shouldShow }) => shouldShow && visiblePopUp};
        &:hover {
            ${visiblePopUp};
        }
    `}
`;

export { Wrap, Button, CartOverlay };
